<style src="./ServiceCorner.scss" lang="scss"></style>

<script>
	import Button from '@/components/Button/Button';

	/**
	 * The bottom right corner of the page that can be filled with different stuff.
	 * Currently containing "Back to Top" and "FAQ".
	 * @vue-prop {string} faqUrl The URL to the FAQ page
	 * @listens Window#scroll
	 */
	export default {
		props: ['faqUrl'],
		methods: {
			/**
			 * Scrolls page back to top.
			 */
			backtotop () {
				let isSafari = /constructor/i.test(window.HTMLElement);
				let isIE = document.body.style.msTouchAction !== undefined;
				if (isSafari || isIE) {
					let startPos = window.pageYOffset;
					let step = 300;
					let int = setInterval(function () {
						window.scrollTo(0, startPos);
						startPos -= step;
						if (startPos < step) {
							window.scrollTo(0, 0);
							clearInterval(int);
						}
					}, 10);
				} else {
					document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		},
		mounted () {
			this.$nextTick(() => {
				try {
					let btt = this.$el.querySelector('[data-service-corner="back-to-top"]') || {};
					let ruler = document.querySelector('[data-content] > section:nth-of-type(2)') || {};
					btt.setAttribute('data-visibility', ruler.getBoundingClientRect().top < 0 ? 'visible' : 'hidden');
					// for performance
					let ticking = false;
					window.addEventListener('scroll', () => {
						if (!ticking) {
							setTimeout(() => {
								btt.setAttribute('data-visibility', ruler.getBoundingClientRect().top < 0 ? 'visible' : 'hidden');
								ticking = false;
							}, 1000);
							ticking = true;
						}
					});
				} catch (error) {
					console.log(error);
				}
			});
		},
		components: {
			'hp-button': Button
		}
	};
</script>

<template>
	<div data-component="service-corner">
		<div data-service-corner="back-to-top" data-visibility="visible">
			<hp-button data-importance="ghost" data-type="icon" href="#app" @click.prevent="backtotop">
				<span></span>
			</hp-button>
		</div>
		<div data-service-corner="faq">
			<hp-button data-importance="accent" data-type="icon" href="faqUrl">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
					<path d="M18.7 20.3c.3-.7.6-1.3 1-2 .4-.5.9-1 1.4-1.5.5-.4.9-.9 1.4-1.3.4-.5.8-1 1-1.5.3-.6.5-1.3.4-2 .1-1-.4-2-1.2-2.7-.9-.6-1.9-.9-3-.9-.8 0-1.6.1-2.3.2-.7.2-1.2.3-1.7.5s-1 .5-1.5.7L13.6 8c1.1-.7 2.3-1.2 3.6-1.5.8-.2 1.6-.3 2.5-.3 2.2 0 3.8.5 4.9 1.6 1.1 1.1 1.7 2.6 1.7 4.1 0 .8-.1 1.6-.4 2.4-.3.6-.6 1.2-1.1 1.8-.4.5-.9 1-1.4 1.4-.5.4-1 .9-1.4 1.4-.4.5-.8 1.1-1.1 1.7-.3.7-.4 1.5-.4 2.4v1.8h-2.4v-1.6c.1-1 .3-2 .6-2.9zM18 33.2c-.3-.4-.5-.8-.4-1.3 0-.5.2-1 .5-1.4.4-.4.9-.6 1.4-.5.5 0 .9.2 1.3.5.3.4.5.9.5 1.4 0 .5-.2 1-.5 1.3-.3.4-.8.6-1.3.5-.6.1-1.2-.1-1.5-.5z" />
				</svg>
			</hp-button>
		</div>
	</div>
</template>
